import { Component } from '@angular/core';
import { SalesAdditionalInformationGeneralComponent } from '../sales-additional-information-general.component';

@Component({
  selector: 'app-sales-additional-information-general-v2',
  templateUrl: './sales-additional-information-general-v2.component.html'
})
export class SalesAdditionalInformationGeneralV2Component extends SalesAdditionalInformationGeneralComponent { }

@Component({
  selector: 'app-sales-additional-information-general-v3',
  templateUrl: './sales-additional-information-general-v3.component.html',
})
export class SalesAdditionalInformationGeneralV3Component extends SalesAdditionalInformationGeneralComponent { }
